var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDownCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#AFAFAF",
  d: "M10 18.576c-5.17 0-9.375-1.771-9.375-3.948S4.831 10.681 10 10.681c5.17 0 9.375 1.77 9.375 3.947S15.169 18.576 10 18.576",
  opacity: 0.4
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#AFAFAF",
  d: "M14.437 5.49 10.661 1.7l-.001-.002-.003-.002-.001-.002-.003-.002V1.69l-.005-.004-.002-.001-.003-.003a.93.93 0 0 0-.62-.257l-.005-.002h-.02c-.008.002-.022.004-.022 0l-.004.002a.94.94 0 0 0-.627.262l-.003.004h-.001l-.009.01-3.77 3.787A.939.939 0 0 0 6.89 6.813l2.17-2.181v7.407a.938.938 0 0 0 1.875 0V4.631l2.175 2.182a.936.936 0 1 0 1.327-1.324"
})));
export default SvgDownCircle;